/**
 * Thin gtag wrapper. No-ops when gtag is unavailable.
 * gstack-shortcut(dec-oral-care-contract-core-pr1): 7/10, upgrade when PR1 RFQ+facts ship
 */

const firedCompareRoutes = new Set()

export function track(event, params = {}) {
  if (typeof window === 'undefined') return
  const gtag = window.gtag
  if (typeof gtag !== 'function') return
  try {
    gtag('event', event, params)
  } catch {
    // Analytics must never break UX
  }
}

/** Fire oral_compare_view once per route path (PR1 mount-once contract). */
export function trackOralCompareViewOnce(pagePath, params = {}) {
  const key = pagePath || 'unknown'
  if (firedCompareRoutes.has(key)) return
  firedCompareRoutes.add(key)
  track('oral_compare_view', { category: 'oralCare', page: key, ...params })
}

export function trackOralRfqClick(product, from) {
  track('oral_rfq_click', { product, from })
}

export function trackContactSubmitSuccess(payload = {}) {
  track('contact_submit_success', payload)
}

/** Test helper */
export function _resetCompareTrackingForTests() {
  firedCompareRoutes.clear()
}
